import { useTranslation } from 'react-i18next';
import { notificationService } from '@/lib/services/notification.service';
import { logger } from '@/lib/utils/logger';
import { UpdateMcpCatalogDto } from '@inference.engine/api-client/web';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { updateMcpCatalog } from '../../api/mcp-catalog.api';
import { ADMIN_QUERY_KEYS } from '../../api';

export const useUpdateCatalogMcp = () => {
  const { t } = useTranslation('admin');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: UpdateMcpCatalogDto }) =>
      updateMcpCatalog(body, id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ADMIN_QUERY_KEYS.mcpCatalog.available });
      // Catalog edits also surface in the user-facing MCP views (My MCPs + chat composer), which
      // read a separate `['user-mcps', …]` query namespace. Admin must not import the
      // user-mcp-servers feature (FSD boundary), so invalidate by its stable root prefix.
      await queryClient.invalidateQueries({ queryKey: ['user-mcps'] });
      notificationService.showSuccess(t('admin.useUpdateCatalogMcp.mcpServerUpdated'));
    },
    onError: (error) => {
      notificationService.showError(t('admin.useUpdateCatalogMcp.failedToUpdateMcpServer'));
      logger.error('Failed to update catalog MCP:', error);
    },
  });
};
